import { Component } from 'react';

// Assets
import client1 from '../../assets/tata.svg';
import client2 from '../../assets/crane.svg';
import client3 from '../../assets/tesla.svg';
import client4 from '../../assets/nikola.svg';
import client5 from '../../assets/bharatForge.svg';
import client6 from '../../assets/bridgestone.svg';
import client7 from '../../assets/bluebird.svg';
import client8 from '../../assets/allison.svg';

export default class Client extends Component {

    render() {

        return (
            <div className='Client'>
                <div className='Client_Title'>Our Clients</div>
                <div className='Client_CompanyBlock'>
                    <div className='Client_ImageBlock'>
                        <div className='Client1'></div>
                        <div className='Client2'></div>
                    </div>
                    <div className='Client_ImageBlock'>
                        <div className='Client3'></div>
                        <div className='Client4'></div>
                    </div>
                    <div className='Client_ImageBlock'>
                        <div className='Client5'></div>
                        <div className='Client6'></div>
                    </div>
                    <div className='Client_ImageBlock'>
                        <div className='Client7'></div>
                        <div className='Client8'></div>
                    </div>
                </div>
            </div>
        );
    }
}